import { JOB_SERVER_URL } from "../../config";
import http from "../../net/http-common";

export const getHexabindProperties = async (task_id: string) => {
  return http.get(`${JOB_SERVER_URL}/hexabind/results`, {
    params: {
      task_id: task_id,
      as_file: false,
    },
    headers: {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });
};
